'use strict';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').controller('HistoricoRecomendacoesCorrecaoSoloCtrl', function($scope, $rootScope, $filter,
  $uibModal, $q, filterFilter, LoadingService, RecomendacoesService, MessagesService, HistoricosService,
  PeriodSelectService, $routeParams, $route, HistoricoRecomendacoesService, DecimalsService) {
  let hasPage = true;
  let inProgress = false;
  let lastFilters = {};
  $scope.initialized = false;
  $scope.loading = false;
  $scope.status = RECOMENDACAO_STATUS;
  $scope.filtroPeriodo = PeriodSelectService.getFilterPeriodo($scope.$root.safras);
  $scope.glebas = $scope.$root.currentPropriedade.glebas;
  $scope.recommendationFilters = {
    page: 1
  };
  $scope.period = {
    eventDates: [],
    periodo: ''
  };

  // PUBLIC FUNCTIONS
  $scope.getRecommendations = function() {
    if ($rootScope.permissions.recomendacao.canRead) {
      const hasFilterPage = $scope.recommendationFilters && $scope.recommendationFilters.page;
      if (hasFilterPage && hasPage && !inProgress) {
        inProgress = true;

        lastFilters = { ...$scope.recommendationFilters };

        return RecomendacoesService
          .listCorrecoes($scope.recommendationFilters)
          .then(function(data) {
            const dados = data.data || [];
            hasPage = (((data.pages || {}).pagination || {}).next || 0) > $scope.recommendationFilters.page;

            if (dados.length > 0) {
              $scope.recommendationFilters.page++;
              dados.forEach(updateRecommendationStatus);
            }

            $scope.recommendations = _.concat($scope.recommendations || [], dados);
            checkRecommendationToOpen();
          })
          .catch((error) => {
            console.error('Erro ao buscar recomendações', error);
            MessagesService.alert('Não foi possível buscar a lista de Recomendações.');
          })
          .finally(function() {
            inProgress = false;
            $scope.loading = false;
          });
      }
    }
  };

  $scope.openRecommendationDetail = function(event, recommendation, forceOpen) {
    if (event) {
      stopPropagation(event);
      preventDefault(event);
    }

    if (!(recommendation || {}).id) {
      return;
    }

    if (!recommendation.open || forceOpen) {
      recommendation.loading = true;
      recommendation.allData = {};

      RecomendacoesService
        .getCorrecao(recommendation.id)
        .then(function(data) {
          adjustRecommendationAllData(recommendation, data);
          $route.updateParams({ activeRecommendation: recommendation.id });
        })
        .catch(function() {
          MessagesService.alert('Não foi possível consultar a recomendação.');
        })
        .finally(function() {
          recommendation.loading = false;
        });
    } else {
      recommendation.open = !recommendation.open;
      $route.updateParams({ activeRecommendation: null });
    }
  };

  $scope.openPeriodsFilter = async function(event) {
    preventDefault(event);
    const periodo = {};

    await PeriodSelectService.openPeriodSelection($scope.period, periodo);
    $scope.setPeriodo(periodo, event);
  };

  $scope.setPeriodo = function(periodo, event) {
    if ($routeParams.date) {
      $route.updateParams({ date: null, historyDate: null });
    }

    if (periodo) {
      const datas = {
        dataInicial: null,
        dataFinal: null,
        period: $scope.period
      };

      datas.dataInicial = periodo.dataInicial._isAMomentObject ?
        periodo.dataInicial.format(MOMENT_DATE_ENGLISH_FORMAT) :
        periodo.dataInicial;

      datas.dataFinal = periodo.dataFinal._isAMomentObject ?
        periodo.dataFinal.format(MOMENT_DATE_ENGLISH_FORMAT) :
        periodo.dataFinal;

      if (periodo.descricao) {
        datas.period.periodo = periodo.descricao;
      }

      $scope.setFilterAttribute(datas, event);
    }
  };


  $scope.reportDemandaUso = function(event) {
    preventDefault(event);

    $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'modal-report-demanda-uso.html',
      controller: 'DemandaUsoInsumosCtrl',
      controllerAs: 'DemandaUsoInsumos',
      resolve: {
        operacao: function() {
          return $rootScope.parametros.operacao_correcao_solo;
        },
        cronograma: function() {
          return false;
        },
        aguardandoAprovacao: function() {
          return false;
        },
        aplicacoes: function() {
          return {};
        }
      }
    });
  };


  $scope.setFilterAttribute = async function(object, event) {
    const { currentTarget } = event;
    event.preventDefault();

    if (currentTarget.id === 'select-gleba' && $routeParams.activeGleba) {
      $route.updateParams({ activeGleba: null });
      await setTimeout([], 10);
    }

    _.assign($scope.recommendationFilters, object);
    HistoricoRecomendacoesService.updateRecommendationFilters($scope.recommendationFilters);

    resetVariables();
    $scope.getRecommendations();
  };

  $scope.canEditRecommendation = function(recommendation) {
    return $rootScope.permissions.recomendacao.canManage &&
      recommendation.status.descricao !== 'aplicada' &&
      recommendation.situacao !== 'rejeitado';
  };

  $scope.calculateTotalProduto = function(produto, areaGleba, shouldRecalculate = true) {
    const quantidadeTotal = produto.qt_dose * areaGleba;

    if (DecimalsService.isDecimalV2Enabled()) {
      const quantidadeTotalProduto = Math.max(+produto.qt_total, 0) > 0 && !shouldRecalculate ?
        +produto.qt_total :
        quantidadeTotal;
      return DecimalsService.formatDoseOrQuantityForDisplay(quantidadeTotalProduto);
    }

    return quantidadeTotal;
  };

  $scope.newRecommendation = function() {
    if (!$rootScope.permissions.recomendacaoCorrecaoSolo.canManage) {
      return;
    }

    $scope.$emit('activateSidebar', 'addRecommendationCorrecao');
  };

  $scope.resetPeriodsFilter = function() {
    $scope.recommendationFilters.dataInicial = null;
    $scope.recommendationFilters.dataFinal = null;
    $scope.period = {
      eventDates: [],
      periodo: ''
    };
  };

  $scope.editRecommendation = function(recommendation) {
    $scope.$emit('edit_correcao', recommendation);
  };

  $scope.concludeRecommendation = function(recommendation) {
    recommendation.waiting = true;
    // eslint-disable-next-line max-len
    const mensagem = 'Deseja encerrar esta recomendação? Ela será finalizada mesmo que não esteja 100% executada. O restante não será realizado, não haverá movimentação de estoque e esta ação é irreversível.';
    MessagesService.confirm(mensagem).then(function() {
      RecomendacoesService.finalizar('aqila_recomendacoes', recommendation.allData).then(function() {
        recommendation.status = RecomendacoesService.getRecomendacaoStatus('finalizado');
        MessagesService.alert('Status de recomendação alterado com sucesso');
      });
    })
      .finally(function() {
        recommendation.waiting = false;
      });
  };

  $scope.showModalImpressao = function(recommendation) {
    $scope.recommendationSelected = recommendation;
    $scope.recommendationSelected.quebrarGleba = true;
    $scope.modalImpressao = $uibModal.open({
      templateUrl: 'views/painel_propriedade/recomendacao/_modal_impressao.html',
      scope: $scope
    });
  };

  $scope.closeModalImpressao = function() {
    $scope.modalImpressao.close();
  };

  // PRIVATE FUNCTIONS
  function getRouteParams() {
    const routeFilters = HistoricoRecomendacoesService.loadRouteFilters({
      recomendantes: $scope.recomendantes,
      statuses: $scope.status,
      gruposInsumo: $scope.gruposInsumos,
      atividades: $scope.atividades
    });

    if (routeFilters.period) {
      $scope.period = routeFilters.period;
      delete routeFilters.period;
    }

    _.assign($scope.recommendationFilters, routeFilters);

    HistoricoRecomendacoesService.updateRecommendationFilters($scope.recommendationFilters);
  }

  function checkRecommendationToOpen() {
    let activeRecommendation;

    if ($scope.recommendations.length === 1) {
      activeRecommendation = $scope.recommendations[0];
    } else if ($routeParams.activeRecommendation) {
      activeRecommendation = $scope.recommendations.find((r) => +r.id === +$routeParams.activeRecommendation);
    }

    if (activeRecommendation) {
      $scope.openRecommendationDetail(null, activeRecommendation, true);
    } else {
      $route.updateParams({ activeRecommendation: null });
    }
  }

  function updateRecommendationStatus(recommendation) {
    recommendation.emAndamento = recommendation.status === 'em_andamento';

    recommendation.glebas = recommendation.glebas.map(function(gleba) {
      gleba.gleba.area_recomendada = gleba.area_recomendada;
      return gleba.gleba;
    });

    if (recommendation.atrasada) {
      recommendation.status = RECOMENDACAO_ATRASADA;
      recommendation.emAndamentoAtrasada = recommendation.emAndamento;
    } else {
      recommendation.status = RecomendacoesService.getRecomendacaoStatus(recommendation.status);
    }
  }

  function setFiltersList([gruposInsumos, atividades, usuarios]) {
    $scope.gruposInsumos = gruposInsumos.data || [];
    $scope.atividades = atividades || [];
    $scope.recomendantes = usuarios.data || [];
  }

  function resetVariables() {
    hasPage = true;
    $scope.recommendationFilters.page = 1;
    $scope.recommendations = [];
    $scope.loading = true;
  }

  function adjustRecommendationAllData(recommendation, data) {
    recommendation.allData = data.data || {};
    recommendation.allData.status = recommendation.status;
    recommendation.allData.glebas = recommendation.allData.glebas.map(function(gleba) {
      gleba.gleba.area_recomendada = gleba.area_recomendada;
      gleba.gleba.aplicada = gleba.aplicada;
      gleba.gleba.percentual_aplicado = gleba.percentual_aplicado;
      return gleba.gleba;
    });
    recommendation.open = true;
  }

  function initialize() {
    if (!$rootScope.permissions.recomendacao.canRead || !filtersChanged()) {
      return;
    }

    resetVariables();
    $scope.loading = true;

    HistoricoRecomendacoesService.getFiltersList('recomendacao_operacao_correcao_solo')
      .then((list) => {
        setFiltersList(list);
        getRouteParams();
        return $scope.getRecommendations();
      })
      .finally(() => $scope.initialized = true);
  }

  function filtersChanged() {
    return !_.isEqualWith($scope.recommendationFilters, lastFilters, function(value, lastValue, key) {
      // Considera null igual a undefined
      if (_.isNull(value) || _.isNull(lastValue)) {
        // eslint-disable-next-line eqeqeq
        return value == lastValue;
      }

      // eslint-disable-next-line no-undefined
      return key === 'page' || undefined;
    });
  }

  // CALLBACKS
  $scope.$on('correcaoActivate', initialize);

  $scope.$on('recommendations_close', () => {
    $route.updateParams({
      recommendationFilters: null,
      activeRecommendation: null
    });
  });

  $scope.$on('update_recomendacao', function(event, recommendation) {
    if (($scope.recommendations || []).length) {
      const filterRecommendation = filterFilter($scope.recommendations, { id: recommendation.id }, true)[0] || {};
      if (filterRecommendation.id) {
        filterRecommendation.situacao = 'rejeitado';
        filterRecommendation.motivo_rejeicao = recommendation.motivo_rejeicao;
      }
    }
  });

  $scope.$on('$routeUpdate', function() {
    if ($scope.initialized) {
      getRouteParams();

      if (filtersChanged()) {
        resetVariables();
        $scope.getRecommendations();
      }
    }
  });
});
